import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index.vue'
import store from '../store/index'

// ----------------------------- o

import { Capacitor } from '@capacitor/core';
import Analytics from '@/services/Analytics';

// ----------------------------- o

Vue.use(Router);

// ----------------------------- o

import Login from '@/views/auth/Login'
import Register from '@/views/auth/Register'
import RegisterToken from '@/views/auth/RegisterToken'
import RegisterDetails from '@/views/auth/RegisterDetails'
import RemindPassword from '@/views/auth/RemindPassword'
import ResetPassword from '@/views/auth/ResetPassword'

// ----------------------------- o

import Notifications from '@/views/notifications/Index'
import Cart from '@/views/cart/Index'

// ----------------------------- o

import Dashboard from '@/views/dashboard/Index'

// ----------------------------- o

import Knowledge from '@/views/knowledge/Index'
import News from '@/views/knowledge/news/Index'
import NewsSingle from '@/views/knowledge/news/NewsSingle'
import Wiki from '@/views/knowledge/wiki/Index'
import Help from '@/views/knowledge/help/Index'
import Brands from '@/views/knowledge/brands/Index'
import BrandsBeerList from '@/views/knowledge/brands/BeerList'
import Foodpairing from '@/views/knowledge/foodpairing/Index'

// ----------------------------- o

import Trainings from '@/views/knowledge/trainings/Index'
import TrainingSingle from '@/views/knowledge/trainings/TrainingSingle'
import TrainingTest from '@/views/knowledge/trainings/TrainingTest'
import TrainingSummary from '@/views/knowledge/trainings/TrainingSummary'
import TrainingExam from '@/views/knowledge/trainings/TrainingExam'

// ----------------------------- o

import Academies from '@/views/knowledge/academies/Index'
import AcademySingle from '@/views/knowledge/academies/AcademySingle'
import AcademyRegister from '@/views/knowledge/academies/AcademyRegister'
import AcademyBookmark from '@/views/knowledge/academies/AcademyBookmark'
import AcademyNews from '@/views/knowledge/academies/AcademyNews'
import AcademyNewsSingle from '@/views/knowledge/academies/AcademyNewsSingle'

// ----------------------------- o

import ShopGlass from '@/views/shop/glass/Index'
import ShopGlassInfo from '@/views/shop/glass/Info'
import ShopGlassOrders from '@/views/shop/glass/Orders'

// ----------------------------- o

import LoyaltyIndex from '@/views/loyalty/Index'
import LoyaltyResults from '@/views/loyalty/Results'
import LoyaltyActivations from '@/views/loyalty/Activations'
import LoyaltyActivationsSingle from '@/views/loyalty/ActivationsSingle'
import LoyaltySignup from '@/views/loyalty/Signup'
import LoyaltySignupActivation from '@/views/loyalty/SignupActivation'
import LoyaltyTerminate from '@/views/loyalty/Terminate'

// ----------------------------- o

import UserProfile from '@/views/user/Index'
//
import UserJoinPlace from '@/views/user/UserJoinPlace'
//
import UserProfileIndex from '@/views/user/profile/Index'
import UserProfileBasic from '@/views/user/profile/Basic'
import UserProfilePhone from '@/views/user/profile/Phone'
import UserProfileToken from '@/views/user/profile/Token'
import UserProfilePassword from '@/views/user/profile/Password'
//
import UserFacilities from '@/views/user/UserFacilities'
import UserFacilitiesDetail from '@/views/user/UserFacilitiesDetail'
//
import UserPlaces from '@/views/user/UserPlaces'
import UserPlacesDetail from '@/views/user/UserPlacesDetail'
//
import UserEmployees from '@/views/user/UserEmployees'
import UserEmployeesDetail from '@/views/user/UserEmployeesDetail'
//
import UserAcademies from '@/views/user/UserAcademies'
//
import UserContact from '@/views/user/UserContact'
import UserContactForm from '@/views/user/UserContactForm'
//
import UserWorkplaces from '@/views/user/UserWorkplaces'
import UserAgreements from '@/views/user/UserAgreements'

// ----------------------------- o

import PhClients from '@/views/ph/PhClients'
import PhClientsDetails from '@/views/ph/PhClientsDetails'
import PhDownloadReportContracts from '@/views/ph/PhDownloadReportContracts'
import PhStatistics from '@/views/ph/PhStatistics'
import PhManuals from '@/views/ph/PhManuals'

// ----------------------------- o

import AsmClients from '@/views/asm/AsmClients'
import AsmFirstLogin from '@/views/asm/AsmFirstLogin'

// ----------------------------- o

import More from '@/views/more/Index'
import Downloads from '@/views/more/downloads/Index'
import DownloadsList from '@/views/more/downloads/DownloadsList'
//
import Regulations from '@/views/more/Regulations'
import About from '@/views/more/About'
import DeleteAccount from '@/views/more/DeleteAccount'

// ----------------------------- o

import Error404 from '@/views/errors/Error404'

// ----------------------------- o

let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // Unauthenticated routes
    { path: '/logowanie', name: 'Login', component: Login },
    { path: '/rejestracja', name: 'Register', component: Register },
    { path: '/token-sms', name: 'RegisterToken', component: RegisterToken },
    { path: '/twoje-dane', name: 'RegisterDetails', component: RegisterDetails },
    { path: '/przypomnij-haslo', name: 'RemindPassword', component: RemindPassword },
    { path: '/resetuj-haslo', name: 'ResetPassword', component: ResetPassword },

    // Authenticated routes

    // Tabs
    { path: '/', name: 'Index', component: Index, meta: { auth: true }, children: [

        // Dashboard
        { path: '/pulpit', name: 'Dashboard', component: Dashboard, meta: { auth: true } },

        // Knowledge
        { path: '/wiedza', name: 'Knowledge', component: Knowledge, meta: { auth: true } },
        { path: '/wiedza/akademie', name: 'Academies', component: Academies, meta: { auth: true } },
        { path: '/wiedza/szkolenia', name: 'Trainings', component: Trainings, meta: { auth: true } },
        { path: '/wiedza/artykuly', name: 'News', component: News, meta: { auth: true } },
        { path: '/wiedza/marki', name: 'Brands', component: Brands, meta: { auth: true } },
        { path: '/wiedza/marki/:slug', name: 'BrandsBeerList', component: BrandsBeerList, meta: { auth: true } },
        { path: '/wiedza/piwopedia', name: 'Wiki', component: Wiki, meta: { auth: true } },
        { path: '/wiedza/foodpairing', name: 'Foodpairing', component: Foodpairing, meta: { auth: true } },

        // Glass shop
        { path: '/szklo', name: 'ShopGlass', component: ShopGlass, meta: { auth: true } },
        { path: '/szklo-info', name: 'ShopGlassInfo', component: ShopGlassInfo, meta: { auth: true } },
        { path: '/szklo/zamowienia', name: 'ShopGlassOrders', component: ShopGlassOrders, meta: { auth: true } },

        // Loyalty program
        { path: '/program-lojalnosciowy', name: 'LoyaltyIndex', component: LoyaltyIndex, meta: { auth: true } },
        { path: '/program-lojalnosciowy/wyniki', name: 'LoyaltyResults', component: LoyaltyResults, meta: { auth: true } },
        { path: '/program-lojalnosciowy/aktywacje', name: 'LoyaltyActivations', component: LoyaltyActivations, meta: { auth: true } },
        { path: '/program-lojalnosciowy/aktywacje/:slug', name: 'LoyaltyActivationsSingle', component: LoyaltyActivationsSingle, meta: { auth: true } },
        { path: '/program-lojalnosciowy/nowa-umowa', name: 'LoyaltySignup', component: LoyaltySignup, meta: { auth: true } },
        { path: '/program-lojalnosciowy/nowa-umowa-aktywacje/:slug', name: 'LoyaltySignupActivation', component: LoyaltySignupActivation, meta: { auth: true } },
        { path: '/program-lojalnosciowy/wypowiedz-umowe', name: 'LoyaltyTerminate', component: LoyaltyTerminate, meta: { auth: true } },

        // Profile
        { path: '/profil', name: 'UserProfile', component: UserProfile, meta: { auth: true } },
        //
        { path: '/profil/twoje-dane', name: 'UserProfileIndex', component: UserProfileIndex, meta: { auth: true } },
        { path: '/profil/twoje-dane/podstawowe', name: 'UserProfileBasic', component: UserProfileBasic, meta: { auth: true } },
        { path: '/profil/twoje-dane/telefon', name: 'UserProfilePhone', component: UserProfilePhone, meta: { auth: true } },
        { path: '/profil/twoje-dane/haslo', name: 'UserProfilePassword', component: UserProfilePassword, meta: { auth: true } },
        { path: '/profil/twoje-dane/token', name: 'UserProfileToken', component: UserProfileToken, meta: { auth: true }, props: { phone_number: null, hash: null } },
        //
        { path: '/profil/twoje-firmy', name: 'UserFacilities', component: UserFacilities, meta: { auth: true } },
        { path: '/profil/twoi-pracownicy', name: 'UserEmployees', component: UserEmployees, meta: { auth: true } },
        { path: '/profil/twoje-akademie', name: 'UserAcademies', component: UserAcademies, meta: { auth: true } },

        // More
        { path: '/wiecej', name: 'More', component: More, meta: { auth: true } },
        { path: '/wiecej/do-pobrania', name: 'Downloads', component: Downloads, meta: { auth: true } },
        { path: '/wiecej/do-pobrania/:slug', name: 'DownloadsList', component: DownloadsList, meta: { auth: true }, props: true },
        { path: '/wiecej/kontakt', name: 'UserContact', component: UserContact, meta: { auth: true } },
        { path: '/wiecej/kontakt/formularz', name: 'UserContactForm', component: UserContactForm, meta: { auth: true } },
        { path: '/wiecej/pomoc', name: 'Help', component: Help, meta: { auth: true } },
        { path: '/wiecej/usuwanie-konta', name: 'DeleteAccount', component: DeleteAccount, meta: { auth: true } },

        //
        { path: '/wiecej/regulamin', name: 'Regulations', component: Regulations, meta: { auth: true }, props: true },
        { path: '/wiecej/o-aplikacji', name: 'About', component: About, meta: { auth: true }, props: true },

        // PH
        { path: '/profil/klienci-ph', name: 'PhClients', component: PhClients, meta: { auth: true } },
        { path: '/profil/statystyki', name: 'PhStatistics', component: PhStatistics, meta: { auth: true } },
        { path: '/profil/raport-umow', name: 'PhDownloadReportContracts', component: PhDownloadReportContracts, meta: { auth: true } },
        { path: '/profil/tutoriale', name: 'PhManuals', component: PhManuals, meta: { auth: true } },
        // ASM
        { path: '/profil/klienci-asm', name: 'AsmClients', component: AsmClients, meta: { auth: true } },

    ] },

    // Single pages ALL roles
    { path: '/wiedza/artykuly/:slug', name: 'NewsSingle', component: NewsSingle, meta: { auth: true } },
    //
    { path: '/wiedza/akademie/:slug', name: 'AcademySingle', component: AcademySingle, meta: { auth: true } },
    { path: '/wiedza/akademie/:slug/formularz-rejestracji', name: 'AcademyRegister', component: AcademyRegister, meta: { auth: true } },
    { path: '/wiedza/akademie/:slug/artykuly', name: 'AcademyNews', component: AcademyNews, meta: { auth: true }, props: true },
    { path: '/wiedza/akademie/:slug/artykuly/:id', name: 'AcademyNewsSingle', component: AcademyNewsSingle, meta: { auth: true }, props: true },
    { path: '/wiedza/akademie/:slug/bookmark/:id', name: 'AcademyBookmark', component: AcademyBookmark, meta: { auth: true }, props: true },
    //
    { path: '/wiedza/szkolenia/:slug', name: 'TrainingSingle', component: TrainingSingle, meta: { auth: true } },
    { path: '/wiedza/szkolenia/:slug/test', name: 'TrainingTest', component: TrainingTest, meta: { auth: true } },
    { path: '/wiedza/szkolenia/:slug/egzamin', name: 'TrainingExam', component: TrainingExam, meta: { auth: true } },
    { path: '/wiedza/szkolenia/:slug/podsumowanie', name: 'TrainingSummary', component: TrainingSummary, meta: { auth: true } },
    //
    { path: '/powiadomienia', name: 'Notifications', component: Notifications, meta: { auth: true } },
    { path: '/koszyk', name: 'Cart', component: Cart, meta: { auth: true } },
    //
    { path: '/profil/dolacz-do-lokalu', name: 'UserJoinPlace', component: UserJoinPlace, meta: { auth: true }, props: true },
    { path: '/profil/twoje-miejsca-pracy', name: 'UserWorkplaces', component: UserWorkplaces, meta: { auth: true }, props: true },
    { path: '/profil/twoje-firmy/:slug', name: 'UserFacilitiesDetail', component: UserFacilitiesDetail, meta: { auth: true }, props: true },
    { path: '/profil/twoje-firmy/:slug/twoje-lokale', name: 'UserPlaces', component: UserPlaces, meta: { auth: true }, props: true },
    { path: '/profil/twoje-firmy/:slug/twoje-lokale/:id', name: 'UserPlacesDetail', component: UserPlacesDetail, meta: { auth: true }, props: true },
    { path: '/profil/twoi-pracownicy/:slug', name: 'UserEmployeesDetail', component: UserEmployeesDetail, meta: { auth: true } },
    { path: '/profil/twoje-zgody', name: 'UserAgreements', component: UserAgreements, meta: { auth: true } },

    // Single pages PH
    { path: '/profil/klienci-ph/:slug', name: 'PhClientsDetails', component: PhClientsDetails, meta: { auth: true } },

    // Single pages ASM
    { path: '/asm-first-login', name: 'AsmFirstLogin', component: AsmFirstLogin, meta: { auth: true } },

    // Error routes
    { path: '*', name: '404', component: Error404 },
  ]
});

// ----------------------------- o

router.beforeEach(async (to, from, next) => {
    let route = router.resolve(to);

    // Analtytics
    if (Capacitor.platform !== 'web') {
        Analytics.logEvent({name: "page_view", params: {'page': to.path}})
    }

    // Auth middleware
    if(to.matched.some(record => record.meta.auth)) {
        /*
            USER IS UNAUTHENTICATED
         */
        if(!store.getters.isAuthenticated) {
            console.log("%c user is unauthenticated! ", 'background: #ff0000; color: #fff', route.route.path);
            //
            next({name: 'Login'})
        }
        /*
            USER IS AUTHENTICATED
         */
        if(store.getters.isAuthenticated){
            console.log('%c user is authenticated ', 'background: #00b000; color: #fff', route.route.path);
            // check if user needs to be redirected (GDPR)
            if(to.name !== 'UserAgreements' && store.getters['profile/getProfile'].redirect_to_agreements){
                console.log('%c user is authenticated and needs to be redirected by GDPR!', 'background: #00b0b0; color: #fff');
                return next({name: 'UserAgreements'})
            }
            //
            next();
        }
    }else{
        // Try to catch 404 exception
        // default * wildcard is not working!
        if(route.resolved.matched.length === 0){
            console.log('%c 404 router exception! ', 'background: #ff6600; color: #fff');
            store.dispatch('GLOBAL_TOAST', 'Nie ma takiej strony.');
            return next({name: 'Dashboard'})
        }
        // Prevent authenticated user to go back to
        // non-authenticated views such as: login, register, remind password etc
        if(store.getters.isAuthenticated){
            if( to.name === 'Login' ||
                to.name === 'Register' ||
                to.name === 'RegisterToken' ||
                to.name === 'RegisterDetails' ||
                to.name === 'ResetPassword' ||
                to.name === 'AsmFirstLogin'){
                console.log('%c user is authenticated but wants to go where he should not!', 'background: #00b0b0; color: #fff');
                //
                return next({name: 'Dashboard'})
            }
        }

        console.log('%c next ', 'background: #ffa500; color: #fff', route.route.path);
        //
        next()
    }
});

// ----------------------------- o

export default router